import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import reducer from './reducers';
import preferencesReducer from '../connected-components/preferences/reducer';

const combinedReducer = combineReducers({
  ...reducer,
  preferences: preferencesReducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === 'logout') {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
